@if(!isCustomerSearch() ){
<app-header></app-header>
  <router-outlet></router-outlet>
  <app-global-loader></app-global-loader>
}
@else{
<!-- <div class="container p-5 mt-5"> -->
  <router-outlet></router-outlet>
  <app-global-loader></app-global-loader>
<!-- </div> -->
}

